export default {
  computed: {
    isUpdateAction() {
      return this.action === 'update';
    },

    isCreateAction() {
      return this.action === 'create';
    },

    action() {
      return this.hasModel ? 'update' : 'create';
    },

    hasModel() {
      return !!this.data;
    },

    updateAuthorization() {
      return this.hasModel ? `${this.resource}-update-${this.data.id}` : null;
    },

    deleteAuthorization() {
      return this.hasModel ? `${this.resource}-delete-${this.data.id}` : null;
    },

    canUpdate() {
      return this.hasModel ? this.$can(this.updateAuthorization) : false;
    },

    canDelete() {
      return this.hasModel ? this.$can(this.deleteAuthorization) : false;
    },
  },

  created() {
    if (this.hasModel) {
      this.$authorization.register([
        this.updateAuthorization,
        this.deleteAuthorization,
      ]);
    }
  },
};
